<template>
  <div class="authResultBody">
    <div class="authResultMain" v-if="code == '1'">
      <img src="@/assets/image/success.png">
      <h2>刷脸完成</h2>
    </div>
    <div class="authResultMain" v-else>
      <img src="@/assets/image/fail.png">
      <h2>刷脸失败</h2>
    </div>
  </div>
</template>

<script>
import '../utils/rem'
export default {
  data() {
    return {
      code: '0'
    }
  },
  mounted() {
    var reg = /[?&]([^?&#]+)=([^?&#]+)/g
    var param = {}
    var ret = reg.exec(window.location.href)
    while (ret) {
      param[ret[1]] = ret[2]
      ret = reg.exec(window.location.href)
    }
    // 慧眼回调参数 passed：1=刷脸成功，0=失败；参数缺失时按失败处理
    this.code = param.passed || '0'
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.authResultBody {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  img {
    width: 120px;
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 27px;
    letter-spacing: 1px;
    text-align: center;
  }
}
</style>